export enum dossierTypeEnum {
    BodyRepair = "body_repair",
    GlassRepair = "glass_repair",
    GlassReplacement = "glass_replacement",
    CaravanRepair = "caravan_repair",
    HailDamage = "hail_damage",
}
